import { Base } from './../base';

export class Present extends Base{
    isDeliveryRequired: boolean;
    points: number;
    image: string;
    file?: string|ArrayBuffer;
    enabled: boolean;
    article: string;
}